import { IMemberByFileToUpload, IMemberByFileData } from '../../../../../../shared/interfaces/manageCollaborators';

export const mapMemberByFileDataToMemberByFileToUpload = (member: IMemberByFileData): IMemberByFileToUpload => {
  return Object.fromEntries(
    Object.entries(member)
      .map(([key, field]) => [key, field?.value])
      .filter(([, value]) => value !== undefined)
  ) as IMemberByFileToUpload;
};
